// React
import React from 'react';
import {
  Col,
  Row,
  Form,
  Modal,
  Label,
  Input,
  Button,
  ModalBody,
} from 'reactstrap';

// Containers Injections
import {
  SelectInput,
  InputCpfCnpj,
  convertEventSelectToTarget,
} from '../../../../../containers/componentsInjection';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Utils
import { cpf } from 'cpf-cnpj-validator';
import '../../../../../../../utils/validation/cpfMethodValidation';

export const ModalDependent = ({
  item,
  toggle,
  isVisible,
  kinshipsData,
  handleSubmit,
  isCPFRequired,
  toggleModalEdit,
  handleDeleteDependents,
  verifyIfExistDependent,
  verifyAgeOfDependent,
  toggleAssistenceDependent,
}) => {
  const dataGender = [
    {
      value: 'F',
      label: 'Feminino',
    },
    {
      value: 'M',
      label: 'Masculino',
    },
  ];

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      customer_id: item ? item.customer_id : '',
      cpf: item ? item.cpf : '',
      name: item ? item.name : '',
      birthdate: item ? item.birthdate : '',
      gender:
        item && item.gender
          ? {
              value: item.gender,
              label: item.gender === 'M' ? 'Masculino' : 'Feminino',
            }
          : null,
      kinship: item
        ? {
            label: item.kinship_name,
            value: item.kinship_id,
          }
        : {},
      funeralAssistance: item ? item.funeral_assistance : false,
      customer_hashid: item ? item.customer_hashid : '',
    },
    validationSchema: Yup.object({
      customer_id: Yup.string().nullable(),
      cpf: isCPFRequired
        ? Yup.string().cpfType('Digite um CPF válido').required()
        : Yup.string().nullable(),
      name: Yup.string().required(),
      birthdate: Yup.string().required(),
      gender: Yup.object().required(),
      kinship: Yup.object().required(),
      customer_hashid: Yup.string().nullable(),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        customer_id: values.customer_id,
        customer_hashid: values.customer_hashid,
        name: values.name,
        cpf: values.cpf,
        gender: values.gender.value,
        birthdate: values.birthdate,
        funeral_assistance: values.funeralAssistance || false,
        kinship_name: values.kinship.label,
        kinship_id: values.kinship.value,
      };

      if (!isCPFRequired) {
        if (values.cpf && !cpf.isValid(values.cpf)) {
          validation.setFieldError('cpf', 'Digite um CPF válido');
          return; // preventing the form from being submitted if the CPF is not valid
        }
      }

      handleSubmit(valuesToSubmit);
      toggle();
      validation.resetForm();
    },
  });

  const onBlurCpf = async (e) => {
    const data = await verifyIfExistDependent(e.target.value);
    if (data) {
      verifyAgeOfDependent(data.birthdate);

      validation.handleChange({
        target: {
          name: 'name',
          value: data.name,
        },
      });
      validation.handleChange({
        target: {
          name: 'customer_id',
          value: data.customer_id,
        },
      });
      validation.handleChange({
        target: {
          name: 'customer_hashid',
          value: data.customer_hashid,
        },
      });
      validation.handleChange({
        target: {
          name: 'birthdate',
          value: data.birthdate,
        },
      });
      validation.handleChange({
        target: {
          name: 'gender',
          value: {
            label: data.gender === 'M' ? 'Masculino' : 'Feminino',
            value: data.gender,
          },
        },
      });
    }
  };

  return (
    <Modal
      isOpen={isVisible}
      toggle={() => {
        toggle();
      }}
      centered
      className="modal-md"
    >
      <Col className="modal-content border-0">
        <Col className="modal-header p-3 bg-soft-info">
          <span className="fs-14 fw-semibold">
            {item ? 'Editar dependente' : 'Novo dependente'}
          </span>
          <Button
            onClick={() => {
              toggle();
            }}
            className="btn-close"
          ></Button>
        </Col>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <ModalBody className="modal-body mb-3">
            <Row className="g-3">
              <Col md={12}>
                <Label>CPF</Label>
                <InputCpfCnpj
                  id="cpf"
                  isCPF={true}
                  disabled={!!item?.customer_id}
                  placeholder="CPF"
                  invalid={validation.touched.cpf && validation.errors.cpf}
                  value={validation.values.cpf}
                  onChange={(e, type) => {
                    if (type === 'CPF') {
                      validation.handleChange(e);
                    }
                  }}
                  onBlur={isCPFRequired ? onBlurCpf : undefined}
                  className="form-control bg-light border-0"
                />
                {validation.touched.cpf && validation.errors.cpf ? (
                  <p className="text-danger fs-11">Digite um CPF válido</p>
                ) : null}
              </Col>
              <Col md={12}>
                <Label>Nome</Label>
                <Input
                  type="text"
                  className="form-control bg-light border-0"
                  placeholder="Digite o nome do dependente"
                  id="name"
                  disabled={!!item?.customer_id}
                  invalid={
                    !!(validation.touched.name && validation.errors.name)
                  }
                  value={validation.values.name}
                  onChange={validation.handleChange}
                />
                <div className="invalid-feedback">Nome não pode ser nulo</div>
              </Col>
              <Col md={4}>
                <Label>Data de nascimento</Label>
                <Input
                  type="date"
                  className="form-control product-price bg-light border-0"
                  placeholder="0.00"
                  id="birthdate"
                  disabled={!!item?.customer_id}
                  value={validation.values.birthdate}
                  invalid={
                    !!(
                      validation.touched.birthdate &&
                      validation.errors.birthdate
                    )
                  }
                  onChange={(e) => {
                    validation.handleChange(e);
                    verifyAgeOfDependent(e.target.value);
                  }}
                />
                <div className="invalid-feedback">
                  Selecione uma data de nascimento válida.
                </div>
              </Col>
              <Col md={4}>
                <Label>Gênero</Label>
                <SelectInput
                  options={dataGender}
                  value={validation.values.gender}
                  isDisabled={!!item?.customer_id}
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget('gender', eventInput)
                    );
                  }}
                  invalid={
                    !!(validation.touched.gender && validation.errors.gender)
                  }
                  inputId="gender"
                  className="form-control bg-light border-0"
                />
                <div className="invalid-feedback">O gênero é obrigatório</div>
              </Col>
              <Col md={4}>
                <Label>Parentesco</Label>
                <SelectInput
                  options={kinshipsData}
                  value={validation.values.kinship}
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget('kinship', eventInput)
                    );

                    if (item === null) {
                      return null;
                    } else {
                      validation.handleSubmit();
                    }
                  }}
                  inputId="kinship"
                  className="form-control bg-light border-0"
                />
              </Col>

              <Col className="mb-3">
                <span id="checkbox-wrapper">
                  <Input
                    className="form-check-input me-2"
                    type="checkbox"
                    id="funeralAssistance"
                    checked={validation.values.funeralAssistance}
                    // value={validation.values.funeralAssistance}
                    onBlur={validation.handleBlur}
                    onChange={(e) => validation.handleChange(e)}
                    invalid={
                      !!(
                        validation.touched.funeralAssistance &&
                        validation.errors.funeralAssistance
                      )
                    }
                    onClick={() => {
                      if (item?.customer_id) {
                        toggleAssistenceDependent(item.customer_id);
                      }
                      if (item === null) {
                        return null;
                      } else {
                        validation.handleSubmit();
                      }
                    }}
                  />
                  <Label for="funeralAssistance">Assistência funerária</Label>
                </span>
              </Col>
            </Row>
          </ModalBody>
          <Row className="modal-footer">
            {item && (
              <Col className="hstack gap-2">
                <Button
                  type="button"
                  onClick={() => {
                    handleDeleteDependents();
                    toggle();
                  }}
                  className="btn-danger"
                >
                  Excluir
                </Button>
              </Col>
            )}
            <Col className="hstack gap-2 justify-content-end">
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-link"
              >
                Cancelar
              </button>
              <Button
                onClick={() => {
                  if (item?.customer_id) {
                    toggleModalEdit();
                    toggle();
                  } else {
                    validation.handleSubmit();
                  }
                }}
                className="btn btn-secondary"
                id="add-btn"
              >
                {!item ? 'Adicionar' : 'Editar'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Modal>
  );
};
